module.exports = "https://static.wanderu.com/static/media/left-black-arrow.35ad3a8f.svg";